export const GSTDETAIL_REPORT_REQUEST = 'GSTDETAIL_REPORT_REQUEST';
export const GSTDETAIL_REPORT_SUCCESS = 'GSTDETAIL_REPORT_SUCCESS';
export const GSTDETAIL_REPORT_FAILURE = 'GSTDETAIL_REPORT_FAILURE';